import getTimeZone from '@afosto/utils/date/getTimeZone';

export default operator => {
  const timezone = getTimeZone();

  switch (operator) {
    case 'lt':
      return [
        {
          quantity: 0,
          key: 'days',
          direction: 'ago',
          at: {
            timezone,
            hour: 0,
            minute: 0,
          },
        },
      ];
    case 'lte':
      return [
        {
          quantity: 1,
          key: 'days',
          direction: 'ahead',
          at: {
            timezone,
            hour: 0,
            minute: 0,
          },
        },
      ];
    case 'gt':
      return [
        {
          quantity: 1,
          key: 'days',
          direction: 'ahead',
          at: {
            timezone,
            hour: 0,
            minute: 0,
          },
        },
      ];
    case 'gte':
      return [
        {
          quantity: 0,
          key: 'days',
          direction: 'ago',
          at: {
            timezone,
            hour: 0,
            minute: 0,
          },
        },
      ];
    default:
      return [
        {
          quantity: 0,
          key: 'days',
          direction: 'ago',
          at: {
            timezone,
            hour: 0,
            minute: 0,
          },
        },
        {
          quantity: 1,
          key: 'days',
          direction: 'ahead',
          at: {
            timezone,
            hour: 0,
            minute: 0,
          },
        },
      ];
  }
};
